import { render, staticRenderFns } from "./currentWord.vue?vue&type=template&id=24ed9fde&"
import script from "./currentWord.vue?vue&type=script&lang=js&"
export * from "./currentWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports